// extracted by mini-css-extract-plugin
export default {"msg_wrapper":"Msg_msg_wrapper__+a0CR","msg_header":"Msg_msg_header__nVok2","msg_header_text":"Msg_msg_header_text__H8fe8","msg_body":"Msg_msg_body__7DlKx"};